import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

//const baseUrl = "http://localhost:9000";
const baseUrl = "https://communityoflearning.accenture.com/communityoflearning-apis";
const getAuthHeader = () => {
  const token = localStorage.getItem("token");
  return {
    headers: {
      Authorization: token,
    },
  };
};

export const fetchQuestions = createAsyncThunk(
  "questions/fetchQuestions",
  async ({ type = null, skill = null, source = null } = {}, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `${baseUrl}/fetchQuestions`,
        {
          ...getAuthHeader(),
          params: {
            ...(type ? { type } : {}),
            ...(skill ? { skill } : {}),
          },
        }
      );

      return response.data;
    } catch (error) {
      return rejectWithValue(
        error.response?.data?.message || "Failed to fetch questions"
      );
    }
  }
);

export const incrementQuestionViews = createAsyncThunk(
  "questions/incrementQuestionViews",
  async (questionId, { rejectWithValue }) => {
    try {
      await axios.post(
        `${baseUrl}/questions/${questionId}/views`,
        {},
        getAuthHeader()
      );
      return questionId;
    } catch (error) {
      return rejectWithValue("Failed to increment views");
    }
  }
);

export const updateQuestion = createAsyncThunk(
  "questions/updateQuestion",
  async ({ questionId, body }, { rejectWithValue }) => {
    try {
      const response = await axios.put(
        `${baseUrl}/questions/${questionId}`,
        { body },
        getAuthHeader()
      );
      return { questionId, body };
    } catch (error) {
      return rejectWithValue("Failed to update question");
    }
  }
);

const questionsSlice = createSlice({
  name: "questions",
  initialState: {
    list: [],
    activeQuestions: [],
    unansweredQuestions: [],
    loading: false,
    error: null,
  },
  reducers: {
    clearQuestions: (state) => {
      state.list = [];
      state.loading = false;
      state.error = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchQuestions.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchQuestions.fulfilled, (state, action) => {
        state.loading = false;
        const { type, source } = action.meta.arg || {};
        if (source === "sidebar") {
          if (type === "active") {
            state.activeQuestions = action.payload;
          }
          if (type === "unanswered") {
            state.unansweredQuestions = action.payload;
          }
          return;
        }
        state.list = action.payload;
      })
      .addCase(fetchQuestions.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      })

      .addCase(incrementQuestionViews.fulfilled, (state, action) => {
        const question = state.list.find(
          (q) => q.id === action.payload
        );
        if (question) {
          question.views = (question.views || 0) + 1;
        }
      })
      .addCase(updateQuestion.fulfilled, (state, action) => {
        const { questionId, body } = action.payload;
        const question = state.list.find(q => q.id === questionId);
        if (question) {
          question.body = body;
        }
      });
  },
});

export const { clearQuestions } = questionsSlice.actions;
export default questionsSlice.reducer;